import React, { Fragment } from "react";
import "./styles.less";
import Accordion from "src/Components/Accordion";
import { FAQQuestionsFincaraiz, FAQQuestionsInfocasas } from "./questions";

type Props = {
	country_code: string;
	site_name: string;
	main_domain: string;
};

const FAQPage = ({ country_code, site_name, main_domain }: Props) => {
	const preguntas = FAQQuestionsInfocasas(main_domain, site_name, country_code);

	const renderQuestions = (questions) => {
		return questions.map((question, index) => (
			<Accordion
				key={`question-${index}`}
				title={question.title}
				content={question.answer}
			/>
		));
	};

	const renderContent = (items) => {
		return items.map((item, index) => (
			<Fragment key={`list-${index}`}>
				<h4>{item.title}</h4>
				<div className="faqPage__questions">
					{renderQuestions(item.questions)}
				</div>
			</Fragment>
		));
	};

	return (
		<div className="faqPage">
			<h2>Preguntas frecuentes</h2>
			<div className="faqPage__content">
				{country_code === "CO"
					? renderContent(FAQQuestionsFincaraiz)
					: renderContent(preguntas)}
			</div>
		</div>
	);
};

export default FAQPage;
